import { render, staticRenderFns } from "./wangeditor.vue?vue&type=template&id=19adacad&scoped=true"
import script from "./wangeditor.vue?vue&type=script&lang=js"
export * from "./wangeditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19adacad",
  null
  
)

export default component.exports